import * as actionTypes from '../actionTypes/ActionTypes';

export const setShowPaymentInfoModal = payload => {
  return {
    type: actionTypes.PAYMENT_LIST.SET_SHOW_PAYMENT_INFO_MODAL,
    payload
  };
};
